import React, { useState } from "react";
import "./CMSDetails.css";
import apiService from "../../../services/api";

export default function DeleteAccount() {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    if (!phone || phone.length !== 10) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }

    try {
      setLoading(true);
      setError(null);
      setMessage(null);

      const res = await apiService.deleteAccount({
        phone,
      });

      setMessage(res?.data?.message || "Account deleted successfully");
      setPhone("");
      setConfirmed(false);
    } catch (err) {
      console.error("Delete Account Error:", err);
      setError(
        err?.response?.data?.message ||
          "Failed to delete account. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cms-container">
      <div className="cms-card">
        <h3 className="cms-item-title">Delete Account</h3>

        <p className="cms-item-content">
          Please enter your registered mobile number. Once confirmed, your
          account and associated data will be permanently deleted.
        </p>

        <input
          type="tel"
          placeholder="Enter registered mobile number"
          className="cms-input"
          maxLength={10}
          value={phone}
          onChange={(e) =>
            setPhone(e.target.value.replace(/\D/g, ""))
          }
          disabled={loading}
        />

        <div className="cms-actions">
          {!confirmed ? (
            <button
              className="cms-btn cms-btn-warning"
              onClick={() => setConfirmed(true)}
              disabled={!phone || loading}
            >
              Proceed
            </button>
          ) : (
            <>
              <button
                className="cms-btn cms-btn-danger"
                onClick={handleDelete}
                disabled={loading}
              >
                {loading ? "Deleting..." : "Confirm Delete"}
              </button>

              <button
                className="cms-btn cms-btn-outline"
                onClick={() => setConfirmed(false)}
                disabled={loading}
              >
                Cancel
              </button>
            </>
          )}
        </div>

        {message && <p className="cms-success">{message}</p>}
        {error && <p className="cms-error">{error}</p>}
      </div>
    </div>
  );
}
